import parseDecimalNumber from 'parse-decimal-number'

const localeFormats = {
  'en-US': ',.',
  'pt-BR': '.,'
}

export default (value, lacale = 'en-US') => {
  const format = localeFormats[lacale]
  return parseDecimalNumber(value, format)
}



// WEBPACK FOOTER //
// ./src/locales/enumber.js